import React, { useState, useEffect } from "react";
import CustomButton from "../../../../components/inputs/button";
import TextField from "../../../../components/inputs/textfield";
import Snackbar from "../../../../components/snackbar/snackbar";
import "./dialog.css";
import { admin_areatype_list, admin_buildup_list } from "../../admin.api";

const Dialog = ({
  open,
  areaId,
  formData: initialFormData,
  edit,
  view,
  areaType,
  handleClose,
  submit,
  locationData,
}) => {
  const [formData, setFormData] = useState({
    area_management_id: areaId,
    ...initialFormData,
  });
  const [submitted, setSubmitted] = useState(false);
  const [buildupData, setBuildupData] = useState([]);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [builtUpList, setBuiltUpList] = useState([
    {
      built_space_type_name: "",
      area_in_sqft: "",
      rupees_in_sqft: "",
    },
  ]);
  useEffect(() => {
    const derivedCategory =
      initialFormData?.area_management_id === 1
        ? "built_up"
        : initialFormData?.area_management_id === 3
        ? "land"
        : "";

    setFormData({
      ...initialFormData,
      area_management_id: areaId,
      category:
        initialFormData?.category !== undefined &&
        initialFormData?.category !== ""
          ? initialFormData.category
          : derivedCategory,
      facility: initialFormData?.facility || "",
    });
  }, [areaId, initialFormData, edit]);

  useEffect(() => {
    fetchBultupData();
  }, []);

  useEffect(() => {
    const isBuiltUp =
      (initialFormData?.area_management_id === 1 ||
        initialFormData?.category === "built_up") &&
      (edit || view);

    if (areaType === "builtup" && isBuiltUp) {
      setBuiltUpList([
        {
          built_space_type_name: initialFormData?.built_space_type?.name || "",
          area_in_sqft: initialFormData?.area_in_sqft || "",
          rupees_in_sqft: initialFormData?.rupees_in_sqft || "",
        },
      ]);
      setFormData((prev) => ({
        ...prev,
        facility: initialFormData?.facility || "",
      }));
    }
  }, [areaType, edit, initialFormData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const fetchBultupData = () => {
    setIsActive(true);
    admin_areatype_list().then((res) => {
      let tdata = res;
      setBuildupData(tdata);
      setIsActive(false);
    });
  };
  const handleBuiltUpChange = (index, e) => {
    const { name, value } = e.target;
    const updatedList = [...builtUpList];
    updatedList[index][name] = value;
    setBuiltUpList(updatedList);
  };

  const addMoreBuiltUp = () => {
    setBuiltUpList([
      ...builtUpList,
      { built_space_type_name: "", area_in_sqft: "", rupees_in_sqft: "" },
    ]);
  };
  const removeBuiltUp = (indexToRemove) => {
    setBuiltUpList((prevList) =>
      prevList.filter((_, index) => index !== indexToRemove)
    );
  };

  const handleNumberChange = (e) => {
    const { name, value } = e.target;
    const validNumber = /^\d*\.?\d*$/;
    if (validNumber.test(value)) {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };
  const handleBuiltUpNumberChange = (index, e) => {
    const { name, value } = e.target;
    const validNumber = /^\d*\.?\d*$/;
    if (validNumber.test(value)) {
      setBuiltUpList((prevList) => {
        const updatedList = [...prevList];
        updatedList[index][name] = value;
        return updatedList;
      });
    }
  };

  const handleCheckChange = (e) => {
    const isChecked = e.target.checked;
    setFormData((prev) => ({
      ...prev,
      tender_publish_status: isChecked ? 1 : 0,
    }));
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) handleClose(1);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    // Validation
    const errors = [];
    const isEmpty = (v) => v === undefined || v === null || String(v).trim() === "";
    const isPositiveNumber = (v) => /^\d*\.?\d+$/.test(String(v)) && Number(v) > 0;

    // Common: location required for most types shown in this dialog
    if (areaType === "builtup" || areaType === "ownland" || areaType === "joint" || areaType === "equiped" || areaType === "landlease") {
      if (isEmpty(formData.location_id)) errors.push("Location is required");
    }

    if (areaType === "builtup") {
      // When builtup, category determines sub-form
      if (isEmpty(formData.category)) errors.push("Category is required");

      if (formData.category === "built_up") {
        if (isEmpty(formData.sub_location)) errors.push("Sub Location is required");
        // Validate each built-up row
        builtUpList.forEach((row, idx) => {
          if (isEmpty(row.built_space_type_name)) errors.push(`Built-up Option ${idx + 1}: Area Type is required`);
          if (isEmpty(row.area_in_sqft) || !isPositiveNumber(row.area_in_sqft)) errors.push(`Built-up Option ${idx + 1}: Area in Sq.ft must be a positive number`);
          if (isEmpty(row.rupees_in_sqft) || !isPositiveNumber(row.rupees_in_sqft)) errors.push(`Built-up Option ${idx + 1}: Base Price (Rupees/sqft) must be a positive number`);
        });
      }

      if (formData.category === "land") {
        if (isEmpty(formData.area_in_acres) || !isPositiveNumber(formData.area_in_acres)) errors.push("Area in Cent must be a positive number");
        if (isEmpty(formData.rupees_in_lakhs_or_acres) || !isPositiveNumber(formData.rupees_in_lakhs_or_acres)) errors.push("Base premium /cent (rupees) must be a positive number");
      }
    }

    if (areaType === "landlease") {
      if (isEmpty(formData.area_in_acres) || !isPositiveNumber(formData.area_in_acres)) errors.push("Area in acres must be a positive number");
      if (isEmpty(formData.rupees_in_lakhs_or_acres) || !isPositiveNumber(formData.rupees_in_lakhs_or_acres)) errors.push("Rs/Lakhs/Acres must be a positive number");
    }

    if (areaType === "equiped") {
      if (isEmpty(formData.facility)) errors.push("Facility is required");
      if (isEmpty(formData.rupees_in_sqft) || !isPositiveNumber(formData.rupees_in_sqft)) errors.push("Base Price (Rupees/sqft) must be a positive number");
    }

    if (errors.length) {
      setSubmitted(false);
      setSnackMessage(errors.join("\n"));
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }

    const updatedFormData = {
      ...formData,
      area_management_id:
        formData.category === "built_up"
          ? 1
          : formData.category === "land"
          ? 3
          : formData.area_management_id,
    };

    let payload = [];

    if (areaType === "builtup" && formData.category === "built_up") {
      payload = builtUpList.map((item) => ({
        area_management_id: 1,
        location_id: updatedFormData.location_id,
        sub_location: updatedFormData.sub_location,
        category: updatedFormData.category,
        facility: updatedFormData.facility,
        ...item,
      }));
    } else {
      payload = [{ ...updatedFormData }];
    }

    submit(formData.uuid, payload)
      .then((res) => {
        setSubmitted(false);
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        setSubmitted(false);
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
      });
  };

  return (
    <>
      {open && (
        <div className="modal-custom-overlay">
          <div className="modal-custom-container">
            <div className="flexDisplay">
              <div className="diaTitleCon">
                {
                  {
                    location: edit
                      ? "Edit Location"
                      : view
                      ? "Location"
                      : "Add Location",
                    builtup: edit
                      ? "Edit Built-up Space/Land"
                      : view
                      ? "Built-up Space on Rent/Month"
                      : "Add Built-up Space/Land",
                    equiped: edit
                      ? "Edit Equipped Facility"
                      : view
                      ? "Equipped Facility"
                      : "Add Equipped Facility",
                    landlease: edit
                      ? "Land on 30 years lease"
                      : view
                      ? "Land on 30 years lease"
                      : "Add Land on 30 years lease",
                    joint: edit
                      ? "Edit Joint Venture"
                      : view
                      ? "Joint Venture"
                      : "Add Joint Venture",
                    ownland: edit
                      ? "Edit Own Land"
                      : view
                      ? "Own Land"
                      : "Add Own Land",
                  }[areaType]
                }
              </div>
              <div className="dia-close" onClick={() => handleClose()}>
                <div className="diaCloseCon">
                  <div className="diaClose">&#10005;</div>
                </div>
              </div>
            </div>
            <div className="tilebar">
              <hr />
            </div>
            <Snackbar
              message={snackMessage}
              error={isSnackError}
              open={snackOpen}
              close={snackbarClose}
            />
            <div className="row">
              <div className="scrollable-form-container">
                <form action="">
                  <div className="row">
                    {(areaType === "builtup" ||
                      areaType === "ownland" ||
                      areaType === "joint" ||
                      areaType === "equiped" ||
                      areaType === "landlease") && (
                      <div className="col-6">
                        <div className="fieldset">
                          <label className="mb-1">Location</label>
                          <select
                            className="form-select form-control mandatory-select"
                            disabled={view}
                            required
                            name="location_id"
                            onChange={handleChange}
                            value={formData.location_id || ""}
                          >
                            <option value="">Location</option>
                            {locationData?.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.locations}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    )}
                    {areaType === "landlease" && (
                      <div className="col-6">
                        <TextField
                          id="outlined-basic"
                          label="Area in acres"
                          name="area_in_acres"
                          variant="outlined"
                          disabled={view}
                          type="text"
                          value={formData.area_in_acres ?? ""}
                          onChange={handleNumberChange}
                          required
                        />
                      </div>
                    )}
                    {areaType === "landlease" && (
                      <div className="col-6">
                        <TextField
                          id="outlined-basic"
                          label="Rs/Lakhs/Acres"
                          name="rupees_in_lakhs_or_acres"
                          variant="outlined"
                          disabled={view}
                          type="text"
                          value={formData.rupees_in_lakhs_or_acres ?? ""}
                          onChange={handleNumberChange}
                          required
                        />
                      </div>
                    )}
                    {areaType === "builtup" && (
                      <>
                        <div className="col-6 mt-2">
                          <TextField
                            label="Sub Location"
                            name="sub_location"
                            disabled={view}
                            type="text"
                            value={formData.sub_location || ""}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        <div className="col-6">
                          <div className="fieldset">
                            <label className="mb-1">Category</label>
                            <select
                              className="form-select form-control mandatory-select"
                              disabled={view || edit}
                              required
                              name="category"
                              onChange={handleChange}
                              value={formData.category || ""}
                            >
                              <option value="">Select Category</option>
                              <option value="land">Land</option>
                              <option value="built_up">Built-up Space</option>
                            </select>
                          </div>
                        </div>
                      </>
                    )}
                    <div className="col-12">
                      {formData.category === "built_up" &&
                        builtUpList.map((item, index) => (
                          <div
                            key={index}
                            className="border border-gray-300 rounded-lg p-3 mb-3"
                            style={{ background: "#fff" }}
                          >
                            <div
                              className="d-flex align-items-center justify-content-between mb-2"
                              style={{ borderBottom: "1px dashed #ddd", paddingBottom: 8 }}
                            >
                              <div style={{ fontWeight: 600 }}>
                                Built-up Option {index + 1}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-6 mt-1">
                                <label className="mb-1">Area Type</label>
                                <select
                                  className="form-select form-control mandatory-select"
                                  name="built_space_type_name"
                                  value={item.built_space_type_name}
                                  onChange={(e) => handleBuiltUpChange(index, e)}
                                  disabled={view}
                                  required
                                >
                                  <option value="">Select Area Type</option>
                                  {Array.isArray(buildupData?.data) &&
                                    buildupData.data.map((data) => (
                                      <option key={data.name} value={data.name}>
                                        {data.name}
                                      </option>
                                    ))}
                                </select>
                              </div>
                              <div className="col-6 ">
                                <TextField
                                  label="Area (in sq.ft)"
                                  name="area_in_sqft"
                                  type="text"
                                  value={item.area_in_sqft}
                                  onChange={(e) => handleBuiltUpNumberChange(index, e)}
                                  disabled={view}
                                  required
                                />
                              </div>
                              <div className="col-6 mt-2">
                                <TextField
                                  label="Base Price (Rupees/sqft)"
                                  name="rupees_in_sqft"
                                  type="text"
                                  value={item.rupees_in_sqft}
                                  onChange={(e) => handleBuiltUpNumberChange(index, e)}
                                  disabled={view}
                                  required
                                />
                              </div>
                              {!view && !edit && (
                                <div className="col-12 d-flex justify-content-end align-items-center gap-2 mt-3">
                                  {builtUpList.length > 1 && (
                                    <button
                                      type="button"
                                      className="btn btn-danger btn-sm"
                                      onClick={() => removeBuiltUp(index)}
                                    >
                                      Remove
                                    </button>
                                  )}
                                  {index === builtUpList.length - 1 && (
                                    <button
                                      type="button"
                                      onClick={addMoreBuiltUp}
                                      className="btn btn-primary btn-sm"
                                    >
                                      Add More
                                    </button>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                    </div>
                    {formData.category === "land" && (
                      <>
                        <div className="col-6">
                          <TextField
                            label="Area (in cent)"
                            name="area_in_acres"
                            value={formData.area_in_acres || ""}
                            onChange={handleNumberChange}
                            disabled={view}
                            required
                          />
                        </div>
                        <div className="col-6">
                          <TextField
                            label="Base Premium(Rupees/cent)"
                            name="rupees_in_lakhs_or_acres"
                            disabled={view}
                            type="text"
                            value={formData.rupees_in_lakhs_or_acres || ""}
                            onChange={handleNumberChange}
                            required
                          />
                        </div>
                      </>
                    )}

                    {areaType === "equiped" && (
                      <div className="col-6">
                        <TextField
                          label="Facility"
                          name="facility"
                          disabled={view}
                          type="text"
                          value={formData.facility || ""}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    )}

                    {areaType === "equiped" && (
                      <div className="col-6">
                        <TextField
                          label="Base Price (Rupees/sqft)"
                          name="rupees_in_sqft"
                          disabled={view}
                          type="text"
                          value={formData.rupees_in_sqft || ""}
                          onChange={handleNumberChange}
                          required
                        />
                      </div>
                    )}
                  </div>
                </form>
              </div>
              {!view && (
                <div className="col-12 mt-4">
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={handleSubmit}
                  >
                    {edit ? "Update" : "Submit"}{" "}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Dialog;
